import { createEmptyDataSources } from '../dataSources';
import { createEmptyKaDefaultGuidelines } from '../kaGuidelineTypes';

const AILabsState = {
  data: {
    title: '',
    model: 'gpt-4.1',
    engineData: {
      engineType: 'ka',
      intentGuideline: '',
      fallbackGuideline: '',
      answeringGuideline: '',
      faqGuideline: '',
      spamFilterGuideline: '',
      personalizationToolChatGuideline: '',
      personalizationToolGenerationGuideline: '',
      guideline: '',
      intents: [],
      dataSources: createEmptyDataSources(),
    },
  },
  etc: {
    creationType: '',
    deaGuideline: '',
    pollingGuideline: '',
    kaIntentGuideline: '',
    kaFallbackGuideline: '',
    kaAnsweringGuideline: '',
    kaFaqGuideline: '',
    kaSpamFilterGuideline: '',
    kaPersonalizationToolChatGuideline: '',
    kaPersonalizationToolGenerationGuideline: '',
    kaDefaultGuidelines: createEmptyKaDefaultGuidelines(),
    kaAnsweringExpanded: false,
    kaIntentExpanded: false,
    kaFallbackExpanded: false,
    kaFaqExpanded: false,
    kaSpamFilterExpanded: false,
    kaPersonalizationToolChatExpanded: false,
    kaPersonalizationToolGenerationExpanded: false,
    pianoExpanded: false,
    capsuleExpanded: false,
    qlikExpanded: false,
    ga4Expanded: false,
    mailchimpExpanded: false,
    parselyExpanded: false,
  },
};

export default AILabsState;
